import { defineComponent as c, computed as n } from "vue";
import "../../../shared/data/configuration/state/index2.js";
import "@ado/base-service";
import "@ado/location-library";
import "@ado/cookie-library";
import "../../../shared/data/csr/state/index2.js";
import { setShowSignInDialog as a } from "../../../shared/data/layout/state/index.js";
import "../../../shared/data/location/state/index.js";
import "../../../shared/data/navigation/state/index2.js";
import "@ado/experiment-library";
import "../../../search/state/index2.js";
import "../../../shared/data/user/state/index2.js";
import "@ado/acs-standard-library";
import { submitInternalEventAndRedirectToPage as s } from "../../../shared/data/tracking/utilities/index.js";
import { TRACKING_EVENTS as r } from "../../../shared/data/tracking/types/index.js";
import { submitInternalEvent as u } from "@ado/tracking-library";
import { useBaseApplicationTranslation as f } from "../../../shared/libraries/local-translations/index.js";
const H = c({
  name: "HeaderSignedOut",
  props: {
    config: {
      type: Object,
      required: !0
    }
  },
  setup(t) {
    const e = function() {
      u(r.HEADER_SIGN_IN_CLICK), a(!0);
    }, o = n(
      () => t.config.createAccountURL
    ), i = n(() => t.config.signInURL), m = () => {
      s(
        r.HEADER_CREATE_FREE_ACCOUNT_CLICK,
        { url: o.value }
      );
    }, { t: p } = f();
    return {
      openSignInDialog: e,
      createAccountURL: o,
      signInURL: i,
      openCreateAccountPage: m,
      t: p
    };
  }
});
export {
  H as default
};
//# sourceMappingURL=index37.js.map
